import { motion } from "framer-motion";
import WhatsAppIcon from "./WhatsAppIcon";
import Reveal, { ease } from "./Reveal";
import { WHATSAPP_URL } from "@/lib/scroll";

export default function CTA() {
  return (
    <section id="contato" className="overflow-hidden bg-olive text-cream" data-testid="cta-section">
      <div className="grid lg:grid-cols-2">
        <div className="flex items-center px-5 py-24 md:px-10 md:py-32 lg:pr-16 lg:pl-[max(2.5rem,calc((100vw-1240px)/2+2.5rem))]">
          <div className="max-w-xl">
            <Reveal>
              <p className="text-xs md:text-sm font-semibold uppercase tracking-[0.32em] text-sun">
                Agendamento
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-6 font-display font-medium text-[clamp(2.4rem,5vw,4.4rem)] leading-[1.04] tracking-[-0.015em]">
                Sua história completa,{" "}
                <em className="font-serifd italic text-sun">sem pressa.</em>
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-6 text-base md:text-lg leading-relaxed text-cream/80">
                Você chama no WhatsApp e escolhe o melhor horário. A primeira conversa já começa a
                mudar a forma de cuidar de você.
              </p>
            </Reveal>
            <Reveal delay={0.24}>
              <motion.a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="cta-whatsapp"
                whileHover={{ scale: 1.04, y: -2 }}
                whileTap={{ scale: 0.97 }}
                transition={{ duration: 0.3, ease }}
                className="mt-11 inline-flex items-center gap-4 rounded-full bg-sun px-10 py-5 text-lg md:text-2xl font-bold text-olive shadow-2xl shadow-olive-deep/50"
              >
                <WhatsAppIcon className="size-6 md:size-7" />
                Agendar pelo WhatsApp
              </motion.a>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-8 font-display italic text-cream/60">
                Consultas particulares · Barra da Tijuca, Rio de Janeiro
              </p>
            </Reveal>
          </div>
        </div>

        <Reveal className="relative min-h-[320px] lg:min-h-[560px]">
          <img
            src="img/sofa.jpg"
            alt="Dra. Mariane Prado sentada no sofá do consultório, sorrindo"
            className="absolute inset-0 size-full object-cover"
            data-testid="cta-photo"
          />
        </Reveal>
      </div>
    </section>
  );
}
